// Environment Variables
export const API_BASE_URL: string = process.env.REACT_APP_API_BASE_URL || "";
export const USER_MANAGEMENT_DOMAIN: string = process.env.USER_MANAGEMENT_DOMAIN || "user-management";

export const DOMAIN = {
    BIOMETRIC : "http://65.2.147.88:3000/",
    METAL_SCORE_CARD : "https://magic-bus.vercel.app/"
}